// import React from 'react';
import '../styles/process-map.css';

const ClientProcessMap = () => (
  <div className="process-map-container">
    <svg height="1200" id="svg1" version="1.1" viewBox="0 0 1700 1200" width="1700">
 <g className="Background" id="layer1">
  <rect height="1200" id="rect1" width="1700" x="0" y="0"/>
 </g>
 <g className="LineArt" id="layer2">
  <g>
    <path className="LargeTop" d="M 375,325 V 130 h 950 v 195 l -475,25 z" id="box1"/>
    <text className="LargeTopText" id="text1" x="849.16406" y="302.25851">1. Managementprozesse / Unternehmenssteuerung</text>
  </g>
  <g>
    <rect className="SmallTop" height="90" id="box1-1" width="206.25" x="400" y="155"/>
    <text className="SmallTopText" id="text1-1" x="502.93555" y="206.42578">Strategie / Ziele</text>
  </g>
  <g>
    <rect className="SmallTop" height="90" id="box1-2" width="206.25" x="631.25" y="155"/>
    <text className="SmallTopText" id="text1-2" x="734.375" y="206.42578">Verbesserungen</text>
  </g>
  <g>
    <rect className="SmallTop" height="90" id="box1-3" width="206.25" x="862.5" y="155"/>
    <text className="SmallTopText" id="text1-3" x="965.625" y="190.42578">
      <tspan className="SmallTopText" id="tspan1-3-1" x="965.625" y="190.42578">Personal-</tspan>
      <tspan className="SmallTopText" id="tspan1-3-2" x="965.625" y="220.42578">entwicklung</tspan>
    </text>
  </g>
  <g>
    <rect className="SmallTop" height="90" id="box1-4" width="206.25" x="1093.75" y="155"/>
    <text className="SmallTopText" id="text1-4" x="1196.875" y="206.42578">Umweltpolitik</text>
  </g>
  <g>
    <path className="LargeMiddle" d="m 375,375 h 815 l 130,225 -130,225 H 375 Z" id="box2"/>
    <text className="LargeMiddleText" id="text2" x="849.94531" y="450.49927">2. Hauptprozesse</text>
  </g>
  <g>
    <path className="SmallMiddle" d="m 425,497.5 h 755 l 45,45 -45,45 H 425 l 45,-45 z" id="box2-1"/>
    <text className="SmallMiddleText" id="text2-1" x="837.625" y="554.09094">Umweltmanagement</text>
  </g>
  <g>
    <path className="SmallMiddle" d="m 425,612.5 h 755 l 45,45 -45,45 H 425 l 45,-45 z" id="box2-2"/>
    <text className="SmallMiddleText" id="text2-2" x="837.57294" y="669.25897">Großhandel Bürobedarf</text>
    </g>
  <g>
  <path className="LargeBottom" d="m 375,875 475,-25 475,25 v 195 H 375 Z" id="box3"/>
  <text className="LargeBottomText" id="text3" x="849.5462" y="903.00208">3. Unterstützungsprozesse</text>
  </g>
  <g>
  <rect className="SmallBottom" id="box3-1" height="65" width="250" x="425" y="920"/>
  <text className="SmallBottomText" id="text3-1" x="550" y="960">Notfall</text>
  </g>
  <g className="Link" onClick={() => window.location.href = '/documents'}>
    <rect className="SmallBottom" id="box3-2" height="65" width="250" x="725" y="920"/>
    <text className="SmallBottomText" id="text3-2" x="850" y="960">
    Rechtsregister / SDBL
    </text>
  </g>
  <g>
    <rect className="SmallBottom" id="box3-3" height="65" width="250" x="1025" y="920"/>
    <text className="SmallBottomText" id="text3-3" x="1150" y="960">Interne Auditierung</text>
  </g>
  <g>
    <rect className="SmallBottom" id="box3-4" height="65" width="250" x="425" y="995"/>
    <text className="SmallBottomText" id="text3-4" x="550" y="1018">
    <tspan className="SmallBottomText" id="tspan3-4-1" x="550" y="1018">Wiederkehrende</tspan>
    <tspan className="SmallBottomText" id="tspan3-4-2" x="550" y="1048">Prüfübersicht</tspan>
    </text>
  </g>
  <g>
    <rect className="SmallBottom" id="box3-5" height="65" width="250" x="725" y="995"/>
    <text className="SmallBottomText" id="text3-5" x="850" y="1035">Dokumentation</text>
  </g>
  <g>
    <rect className="SmallBottom" id="box3-6" height="65" width="250" x="1025" y="995"/>
    <text className="SmallBottomText" id="text3-6" x="1150" y="1035">Kommunikation</text>
  </g>
  <g>
    <path className="Sides" d="m 225,350 h 100 l 25,250 -25,250 H 225 Z" id="box4-1"/>
    <text className="SidesText" id="text4-1" transform="rotate(-90)" x="-600" y="290">Kundenforderung</text>
  </g>
  <g>
    <path className="Sides" d="m 1350,350 h 125 v 500 h -125 l 25,-250 z" id="box4-2"/>
    <text className="SidesText" id="text4-2" transform="rotate(-90)" x="-600" y="1438.708">Kundenzufriedenheit</text>
  </g>
  <g>
    <path className="ArrowDark" d="m 350,260 c -60,0 -250,65 -250,330 v 0 C 100,247.5 290,200 350,200 Z" id="arrow1-1"/>
    <path className="ArrowLight" d="m 100,590 c 0,67.5 32.44758,331 190,330 v -30 l 60,60 -60,60 v -30 c -35,0 -190,0 -190,-390 z" id="arrow1-2"/>
    <text className="ArrowText" id="text5-1" x="188.30162" y="1060.052">fortlaufende Verbesserung</text>
  </g>
  <g>
    <path className="ArrowDark" d="m 1351.2071,933.50521 c 60,0 250,-65 250,-330 v 0 c 0,342.5 -190,390 -250,390 z" id="arrow2-1"/>
    <path className="ArrowLight" d="m 1601.2071,603.50521 c 0,-67.5 -32.4476,-331 -190,-330 v 30 l -60,-60 60,-60 v 30 c 35,0 190,0 190,390 z" id="arrow2-2"/>
    <text className="ArrowText" id="text5-2" x="1511.9275" y="175.05206">fortlaufende Verbesserung</text>
  </g>
 </g>
</svg>

  </div>
);

export default ClientProcessMap;
